import { getSalonAdminApiBaseUrl } from '../salon-admin/utils/apiConfig';
import { franchiseAuthHeaders } from '../shared/franchiseFlowAuth';
import { fetchAdminWithRetry } from './fetchAdminWithRetry';

/** Staff list for kiosk service session / stylist pick (salon APK flow). */
export async function fetchFranchiseStaffCatalog() {
  const base = (getSalonAdminApiBaseUrl() || '').replace(/\/$/, '');
  if (!base) throw new Error('Admin API unavailable');
  const res = await fetchAdminWithRetry(`${base}/franchise-staff/catalog?_=${Date.now()}`, {
    cache: 'no-store',
    credentials: 'include',
    headers: franchiseAuthHeaders(),
    timeoutMs: 25000,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Failed to load staff');
  return Array.isArray(data.staff) ? data.staff : [];
}
